export default __webpack_public_path__ + "static/media/remove.e774898e.svg";